module.exports = __webpack_public_path__ + "static/logo-b-d198a66200965b9a67f749f627cdb9df.png";